"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeaderFileInfoView = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));
var _view = require("@react-spectrum/view");
var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));
var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
var _FileUtils = _interopRequireDefault(require("../../../../util/FileUtils"));
var _AppConstants = _interopRequireDefault(require("../../../../constants/AppConstants"));
var _SaveActionView = _interopRequireDefault(require("../../header/presentation/save-action/SaveActionView"));
require("!style-loader!css-loader!./HeaderFileInfoView.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

class HeaderFileInfoView extends _react.default.PureComponent {
  getHeaderInfoView(fileDisplayInfo, showFileExtension) {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(["sdk-HeaderFileInfoView-fileBreadCrumb", "sdk-HeaderFileInfoView-fileBreadCrumbNormal", {
        "sdk-HeaderFileInfoView-fileBreadCrumbINT": appStore.isIntegration
      }])
    }, fileDisplayInfo.displayFileName, showFileExtension && /*#__PURE__*/_react.default.createElement("span", {
      className: "sdk-HeaderFileInfoView-details",
      "aria-hidden": true
    }, fileDisplayInfo.extension));
  }
  render() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const {
      fileMetadata,
      fileStatus,
      showSaveButton,
      disableSaveButton,
      status,
      showFileName
    } = this.props;
    const parentItem = [];
    let fileDisplayInfo = {};
    if (showFileName) {
      if (appStore.configStore.isThumbnailView && appStore.fileInfoList.length > 1) {
        fileDisplayInfo.displayFileName = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "multiple.files.header"
        });
      } else {
        fileDisplayInfo = (0, _FileUtils.default)(fileMetadata);
      }
      const showFileExtension = appStore.enableModernViewer || fileDisplayInfo.extension !== "PDF";
      parentItem.push(this.getHeaderInfoView(fileDisplayInfo, showFileExtension));
    }
    let headerClass = "sdk-HeaderFileInfoView-header";
    if (!(appStore.showBrandingInHeader || appStore.getActionConfig("preview").showPreviewHomeButton)) {
      headerClass = "sdk-HeaderFileInfoView-headerNoBranding";
    }
    if (appStore.enableModernViewer) {
      headerClass += " sdk-HeaderFileInfoView-header-fileInfoHorizontallyCentered";
    }
    let statusBlockBorderClass = "";
    if (status || !appStore.configStore.getConfig().leftAlignFileName) {
      statusBlockBorderClass = "sdk-HeaderFileInfoView-statusBlockBorder";
    }
    const hideDisabledSaveButton = disableSaveButton && !appStore.getActionConfig("preview").showDisabledSaveButton;
    const FileStatusModernViewer = props => {
      let showFileStatus = !!fileStatus;
      const saveCallbackConfig = appStore.configStore.getSaveCallbackConfig();
      if (saveCallbackConfig.autoSaveFrequency > 0) {
        // auto-save is enabled, hiding 'EDITED' file status
        showFileStatus = fileStatus && fileStatus !== _AppConstants.default.FILE_PROGRESS_STATUS.EDITED;
      }
      const getFileStatusMessageId = fileSts => ({
        [_AppConstants.default.FILE_PROGRESS_STATUS.EDITED]: "file.progress.status.unsaved"
      })[fileSts] || fileSts;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: appStore.enableModernViewer && props.className,
        "aria-hidden": true
      }, appStore.enableModernViewer && showFileStatus && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: getFileStatusMessageId(fileStatus)
      }));
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: headerClass,
      "aria-hidden": true
    }, /*#__PURE__*/_react.default.createElement(FileStatusModernViewer, {
      className: "sdk-HeaderFileInfoView-fileStatus-modernViewer"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: appStore.isIntegration && (appStore.showBrandingInHeader || appStore.getActionConfig("preview").showPreviewHomeButton) && !appStore.enableModernViewer && "sdk-HeaderFileInfoView-seperatorLine"
    }), showFileName && fileDisplayInfo.displayFileName && /*#__PURE__*/_react.default.createElement("span", {
      className: "sdk-HeaderFileInfoView-breadcrumbs"
    }, /*#__PURE__*/_react.default.createElement(_view.Content, null, parentItem)), !appStore.enableModernViewer && fileStatus && /*#__PURE__*/_react.default.createElement("span", {
      className: "sdk-HeaderFileInfoView-fileStatus",
      "aria-hidden": true
    }, /*#__PURE__*/_react.default.createElement("span", null, "\u2014"), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: fileStatus
    })), (showSaveButton || status) && /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(["sdk-HeaderFileInfoView-statusBlock", statusBlockBorderClass, hideDisabledSaveButton && !status ? "sdk-HeaderFileInfoView-displayNone" : ""])
    }, showSaveButton && /*#__PURE__*/_react.default.createElement(_SaveActionView.default, {
      classNames: ["sdk-HeaderFileInfoView-save"]
    }), status && /*#__PURE__*/_react.default.createElement("span", {
      className: "sdk-HeaderFileInfoView-readOnly"
    }, status === "file.metadata.readonly" && /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
      delayShow: "1000",
      trigger: "hover",
      placement: "right"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      quiet: true,
      className: "sdk-HeaderFileInfoView-readOnlyTooltip"
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: status
    })), /*#__PURE__*/_react.default.createElement(_Tooltip.default, null, this.props.intl.formatMessage({
      id: "file.readonly.tooltip"
    }))), status !== "file.metadata.readonly" && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: status
    }))));
  }
}
exports.HeaderFileInfoView = HeaderFileInfoView;
HeaderFileInfoView.propTypes = {
  fileStatus: _propTypes.default.string,
  fileMetadata: _propTypes.default.objectOf(_propTypes.default.any).isRequired,
  status: _propTypes.default.string.isRequired,
  showSaveButton: _propTypes.default.bool,
  disableSaveButton: _propTypes.default.bool,
  showFileName: _propTypes.default.bool,
  intl: _propTypes.default.object.isRequired
};
HeaderFileInfoView.defaultProps = {
  showFileName: true,
  fileStatus: null,
  disableSaveButton: null,
  showSaveButton: null
};
var _default = exports.default = (0, _reactIntl.injectIntl)(HeaderFileInfoView);